export const cacheSessFieldData = (data) => [
  {
    name: "sessionTime",
    value: data.sessionTime,
    label: "Session Time",
    type: "number",
  },
  {
    name: "daysRangeFrom",
    value: data.daysRangeFrom,
    label: "Days Range From",
    type: "number",
  },
  {
    name: "daysRangeTo",
    value: data.daysRangeTo,
    label: "Days Range To",
    type: "number",
  },
];
